import { Phone, MessageSquare, Mail, ShieldCheck, Leaf, MapPin, BadgeCheck } from "lucide-react";

export const Footer = () => {
  return (
    <footer data-testid="site-footer" className="bg-[#1a1a1a] text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14 grid gap-10 md:grid-cols-4">
        <div className="md:col-span-2">
          <h3 className="font-display text-2xl font-extrabold">Come Pick Up My Trash</h3>
          <p className="mt-3 text-white/70 max-w-md">
            Simple, transparent, reliable junk removal serving Cuyahoga County, Ohio.
            Book online. We show up. We haul it away.
          </p>
          <div className="mt-6 flex flex-wrap gap-3 text-sm">
            <span className="inline-flex items-center gap-2 bg-white/10 px-3 py-1.5 rounded-full">
              <ShieldCheck size={14} className="text-[#ff8c42]" /> Fully Insured
            </span>
            <span className="inline-flex items-center gap-2 bg-white/10 px-3 py-1.5 rounded-full">
              <BadgeCheck size={14} className="text-[#ff8c42]" /> Licensed
            </span>
            <span className="inline-flex items-center gap-2 bg-white/10 px-3 py-1.5 rounded-full">
              <Leaf size={14} className="text-[#ff8c42]" /> Eco-Friendly
            </span>
            <span className="inline-flex items-center gap-2 bg-white/10 px-3 py-1.5 rounded-full">
              <MapPin size={14} className="text-[#ff8c42]" /> Local Business
            </span>
          </div>
        </div>
        <div>
          <h4 className="font-bold text-white mb-4">Contact</h4>
          <ul className="space-y-3 text-white/80 text-sm">
            <li className="flex items-center gap-2">
              <Phone size={14} className="text-[#ff8c42]" /> (216) 306-2330
            </li>
            <li className="flex items-center gap-2">
              <MessageSquare size={14} className="text-[#ff8c42]" /> Text (216) 306-2330
            </li>
            <li className="flex items-center gap-2">
              <Mail size={14} className="text-[#ff8c42]" /> bookings@comepickupmytrash.com
            </li>
          </ul>
        </div>
        <div>
          <h4 className="font-bold text-white mb-4">Company</h4>
          <ul className="space-y-3 text-white/80 text-sm">
            <li><a href="/faq" data-testid="footer-faq-link" className="hover:text-[#ff8c42]">FAQ</a></li>
            <li><a href="/#pricing" className="hover:text-[#ff8c42]">Pricing</a></li>
            <li><a href="/#area" className="hover:text-[#ff8c42]">Service area</a></li>
            <li><a href="#" className="hover:text-[#ff8c42]">Privacy Policy</a></li>
            <li><a href="#" className="hover:text-[#ff8c42]">Terms of Service</a></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-5 flex flex-col sm:flex-row justify-between items-center gap-2 text-xs text-white/50">
          <span>© {new Date().getFullYear()} Come Pick Up My Trash. All rights reserved.</span>
          <span>Proudly serving Cleveland & Cuyahoga County, OH.</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
